//these errors appears for valid liquidJs code in monaco editor, so we have to ignore them
import { LIQUID_JS_FILTERS_NAMES } from '@dealstack/shared/lib/common/liquidJs/liquidJs.ts';

export const TS_ERRORS_TO_IGNORE = [
	2304, // Cannot find name.
	1005, // ',' expected.
	2362, // The left-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type.,
	2695, // Left side of comma operator is unused and has no side effects
];

/**
 * Converts an array of strings or numbers representing a namespace path
 * into a LiquidJS-compatible string representation.
 *
 * Numeric elements in the array are wrapped in square brackets to
 * denote array indexing.
 *
 * @param {string[]} namespace - An array of strings or numbers representing
 * the hierarchy of keys/indices for the target LiquidJS path.
 * @returns {string} A LiquidJS-compatible string representation of the given namespace.
 */
export const convertArrayPathLiquidJsCode = (namespace: string[]): string => {
	let path = '';

	for (const key of namespace) {
		if (!isNaN(Number(key))) {
			path += `[${key}]`;
		} else {
			path += path ? `.${key}` : key;
		}
	}

	return `{{${path}}}`;
};

export const SUGGESTIONS_SETTINGS = {
	//show custom const
	showProperties: true,

	//show properties of objects
	showFields: true,

	//show liquidJs filters
	showConstants: true,

	showIcons: false,
	showMethods: false,
	showFunctions: false,
	showConstructors: false,
	showDeprecated: false,
	showVariables: false,
	showClasses: false,
	showStructs: false,
	showInterfaces: false,
	showModules: false,
	showEvents: false,
	showUnits: false,
	showValues: false,
	showEnums: false,
	showEnumMembers: false,
	showOperators: false,
	showKeywords: false,
	showWords: false,
	showColors: false,
	showFiles: false,
	showReferences: false,
	showFolders: false,
	showTypeParameters: false,
	showIssues: false,
	showUsers: false,
	showSnippets: false,
};

export const getLiquidJsFiltersSuggestions = (range) => {
	return LIQUID_JS_FILTERS_NAMES.map((filter) => ({
		label: filter,
		kind: 14,
		insertText: filter,
		documentation: `LiquidJs filter: ${filter}`,
		range,
	}));
};
